/**
 * Totemo Follow Relay
 * Handles artist and fan follow actions via Vercel serverless functions
 */
window.TotemoFollowRelay = {
  async followArtist({ fanEmail, artistHandle, source = "artist_page" }) {
    if (!fanEmail || !artistHandle) {
      throw new Error("Missing fanEmail or artistHandle");
    }

    const idempotencyKey =
      "artist-follow:v1:" +
      fanEmail.toLowerCase() +
      ":" +
      artistHandle.toLowerCase();

    const response = await fetch(
      "https://totemo-follow-relay.vercel.app/api/follow/artist",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-follow-relay-secret": window.__FOLLOW_RELAY_SECRET__ || ""
        },
        body: JSON.stringify({
          fan_email: fanEmail,
          artist_handle: artistHandle,
          source,
          idempotency_key: idempotencyKey
        })
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Follow failed: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    
    if (!result.ok) {
      throw new Error(result.error || "Follow failed");
    }

    return result;
  }
};
